<template>
  <div class="foundPersonDetail">
    <div class="card">
      <div class="iconAndTitle clearfix">
        <div class="iconFoundPerson" v-if="found.type == '0'">寻人</div>
        <div class="iconRecruit" v-else>招聘</div>
        <div class="title">{{ found.title }}</div>
      </div>
      <div class="date">{{ found.publish_time }}</div>
      <div class="word">{{ found.content }}</div>
    </div>
    <div class="contactBtnDiv">
      <button class="contactBtn" @click="contactShow">立即联系</button>
    </div>
    <van-action-sheet v-model="show" cancel-text="取消" description="联系电话">
      <div class="content" v-if="this.found.phone !== ''">
        <a :href="'tel' + ':' + this.found.phone">{{ this.found.phone }}</a>
      </div>
      <div
        class="content"
        v-else-if="this.found.phone == '' && this.found.email !== ''"
      >
        {{ this.found.email }}
      </div>
      <div class="content" v-else>暂无联系方式</div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      found: "",
      show: false,
    };
  },
  created() {
    this.getFound();
  },
  methods: {
    async getFound() {
      /* const result = await this.$http({
        url: "/findpeopledetail",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({ fid: this.$route.query.fid }),
      }); */
      const result = await this.$http.get("/peopleSearch/getPhone", {
        params: { id: this.$route.query.id }
      });
      this.found = result.data;
    },
    contactShow() {
      this.show = true;
    },
  },
};
</script>
<style lang="less" scoped>
.foundPersonDetail {
  position: relative;
  .card {
    position: relative;
    left: 5%;
    width: 90%;
    min-height: 80vh;
    margin-top: 15px;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;
    .iconAndTitle {
      margin: 5px 0 10px 5px;
      .iconFoundPerson {
        float: left;
        background: linear-gradient(270deg, #00706E, #00706E);
        font-weight: 400;
        color: #ffffff;
        border-radius: 15px;
        padding: 2px 8px;
      }
      .iconRecruit {
        float: left;
        background: linear-gradient(-90deg, #00706E, #00706E);
        font-weight: 400;
        color: #ffffff;
        border-radius: 15px;
        padding: 2px 8px;
      }
      .title {
        float: left;
        padding-top: 2px;
        margin-left: 8px;
        font-weight: bold;
        color: #333333;
      }
    }
    .word {
      position: relative;
      left: 2%;
      width: 96%;
      margin-bottom: 35px;
      text-indent: 2em;
      font-weight: 400;
      color: #666666;
      line-height: 1.5em;
      word-wrap: break-word;
      word-break: break-all;
    }
    .date {
      position: relative;
      left: 5%;
      margin-bottom: 10px;
      font-weight: 400;
      color: #999999;
    }
  }
  .content {
    padding: 15px 0;
    text-align: center;
    a {
      font-weight: bold;
      color: #333333;
      font-size: 1.2rem;
    }
    a:link {
      text-decoration: none;
    }
  }
  .contactBtnDiv {
    position: relative;
    left: 5%;
    width: 90%;
    margin-top: 30px;
    .contactBtn {
      border: 0;
      background: linear-gradient(270deg, #00706E, #00706E);
      color: white;
      width: 100%;
      padding: 10px 0;
      font-size: 1.2rem;
      font-weight: bold;
    }
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/service/FoundPersonDetail.vue